module.exports = __webpack_public_path__ + "img/journey1.6b57f2a2.png";